import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=4ad206a4&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sacha\\dotnet\\ChoupsBooking\\src\\Satrabel.ChoupsBooking\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4ad206a4', component.options)
    } else {
      api.reload('4ad206a4', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=4ad206a4&", function () {
      api.rerender('4ad206a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/calendar/layout.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/layout.vue
// module id = 329
// module chunks = 2